$(document).ready(function() {
	setTimeout(getStateOrder,3000);
});

function getStateOrder() {
	let divStateorder = document.getElementById('data-stateorder');
	
	if (divStateorder) {
		let dataStateorder = JSON.parse(divStateorder.innerHTML);
		
		$.ajax({
				url : dataStateorder.url,
		        type : 'POST',
		        data :  {
					'idOrder' : dataStateorder.idOrder,
				},
		        dataType : 'html',
				success : function (response) {
					var data = JSON.parse(response);
					//console.log(data);
					switch(data.data.state) {
						case 'authorized':
						case 'waiting':
						case 'uncleared':
							setTimeout(getStateOrder,3000);
							break;
					}
					$('#label').html(data.data.html);
					console.log(dataStateorder.redirectUrl);
					if(dataStateorder.redirectUrl && data.data.state=='paid') {
						setTimeout(function(){
							window.location.href = dataStateorder.redirectUrl;
						}, 5000);
					}
				},
		});
	}	
}
